module.exports = __webpack_public_path__ + "img/20191006111520360截图20191006111128808.f1fc1c23.jpg";